import HttpRequest from "@/util/HttpRequest";

export default {
  // eslint-disable-next-line no-empty-pattern
  async LOAD_EMPLOYEE_LIST({ commit }, params) {
    if (!params.projectId) return;

    const option = {
      params: {
        page: params.page,
        perPage: params.perPage,
        order_by: params.order_by,
        order_direction: params.order_direction,
        company_id: params.company_id,
        com_name: params.com_name,
        field_ids: params.field_ids,
        employee_id: params.employee_id,
        job_category: params.job_category,
        employment_type: params.employment_type,
        job_title: params.job_title,
        from_hire_date: params.from_hire_date,
        to_hire_date: params.to_hire_date,
        from_current_position_date: params.from_current_position_date,
        to_current_position_date: params.to_current_position_date,
        from_retirement_date: params.from_retirement_date,
        to_retirement_date: params.to_retirement_date,
        contact_number: params.contact_number,
        keyword: params.keyword,
        comType: params.comType,
        fieldId: params.fieldId,
        ids: params.ids,
      },
    };

    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/employee/${params.projectId}`, option)
        .then((response) => {
          resolve(response);
          commit("LOAD_EMPLOYEE_LIST", response);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 종사자 상세 정보를 조회한다
   *
   * @param params
   * @returns {Promise<unknown>}
   * @constructor
   */
  // eslint-disable-next-line no-empty-pattern
  async LOAD_EMPLOYEE_DETAIL({}, params) {
    if (!params.projectId) return;

    // params.id 또는 params.post_id 둘 중 하나가 전달되지 않으면 빠져나간다
    if (!params.id && !params.post_id) return;

    const option = {
      params: {
        id: params.id,
        post_id: params.post_id,
      },
    };
    if (params.date_name) {
      option.params.date_name = params.date_name
    }
    if (params.board_ids) {
      option.params.board_ids = params.board_ids
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/employee/${params.projectId}/detail`, option)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },
};
